// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".article-tag-view{padding:.625rem}.article-tag-view .article-tag-title{font-size:1rem;background:#f2f2f2}.article-tag-view .article-tag-group{padding:10px}.article-tag-view .van-tag--default{margin:.3125rem}.article-tag-view .van-tag--medium{font-size:1rem}.article-tag-view .article-tag-group .article-tag{color:#222;border-color:1px solid #ccc;background:-webkit-gradient(linear,left top,left bottom,from(#fff),to(#f1f1f1));background:linear-gradient(#fff,#f1f1f1)}", ""]);
// Exports
module.exports = exports;
